module.exports = __webpack_public_path__ + "static/media/ottawa-62.72d91fb4.jpg";